import { useQuery } from "@tanstack/react-query";
import { getAdminRegistrations } from "@/api/admin";

export const useRegistrations = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ["admin", "registrations", params],
    queryFn: () => getAdminRegistrations(params),
    keepPreviousData: true,
    ...options,
  });
};
